var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIconReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 6.75a2 2 0 0 1 1.999-2h10.498a2 2 0 0 1 2 2v10.5a2 2 0 0 1-2 2H6.749a2 2 0 0 1-2-2V6.75zM8.748 15.25v-5.5M15.247 15.25v-5.5M11.998 15.25v-2.5",
    stroke: "#2E2F32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconReporting);
export default __webpack_public_path__ + "static/media/nav-icon-reporting.a78498406ae67a82409c894a05489bf7.svg";
export { ForwardRef as ReactComponent };